import * as Yup from "yup";

export const VacancySchema = Yup.object({
    job_position: Yup.string().required("Job position is required"),
    course_id: Yup.string().required("Please select course"),
    experience: Yup.string().max(50, 'Please enter max 50 charecters.').required("Please enter experience"),
    // description: Yup.string().required("Please enter description"),
});